import { IoChevronBackOutline, IoCloseOutline } from "react-icons/io5";
import "./ShopsMapPage.scss";
import { Map, Marker } from "@vis.gl/react-google-maps";
import { useEffect } from "react";
import { useAmplitude } from "../../../../context/AmplitudeContext";
import { useUID } from "../../../../context/UIDContext";

export const ShopsMapPage = ({
  userLocation,
  nearestShops,
  onBackClick,
  onExitClick,
}) => {
  const trackEvent = useAmplitude();
  const { uid } = useUID();

  useEffect(() => {
    trackEvent("webapp_user_visited_maps_page", uid);
  }, [uid, trackEvent]);

  return (
    <div className="shops-map-page">
      <div className="shops-map-page-top-container">
        <div className="shops-map-page-back-button-wrapper">
          <div className="back-icon" onClick={() => onBackClick()}>
            <IoChevronBackOutline />
          </div>
        </div>
        <div className="shops-map-page-top-header">
          <p>Find Your Products in the Nearest Store</p>
        </div>
        <div className="shops-map-page-close-button-wrapper">
          <div className="close-icon" onClick={onExitClick}>
            <IoCloseOutline />
          </div>
        </div>
      </div>
      <div className="shops-map-page-white-area">
        <div className="map-container">
          <h4 className="map-title">Your Stores:</h4>
          <div className="google-map-container">
            <Map
              defaultCenter={{ lat: userLocation.lat, lng: userLocation.lng }}
              defaultZoom={userLocation.zoom}
              mapId="123awre"
            >
              {nearestShops.map((store, index) => (
                <Marker
                  key={index}
                  position={{ lat: store.lat, lng: store.lng }}
                  onClick={() => {
                    const newWindow = window.open(
                      `https://www.google.com/maps?q=${store.lat},${store.lng}`,
                      "_blank",
                      "noopener,noreferrer",
                    );
                    if (newWindow) newWindow.opener = null;
                  }}
                />
              ))}
            </Map>
          </div>
        </div>

        <div className="shops-container">
          {nearestShops && nearestShops.length > 0 ? (
            nearestShops.map((shopItem, index) => (
              <div key={index} className="shop-item">
                <h4 className="shop-name">{shopItem.name}</h4>
                <a
                  href={`https://www.google.com/maps?q=${shopItem.lat},${shopItem.lng}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="shop-google-link"
                >
                  Show on Google Map
                </a>
              </div>
            ))
          ) : (
            <h4>Sorry no shop found near you. Try different address.</h4>
          )}
        </div>
      </div>
    </div>
  );
};
